import React from 'react';
import './AboutSection.css';

export default function AboutSection() {
  return (
    <section id="about-section" className="about-section">
      <div className="about-container">

        {/* Amacımız-Yaklaşımımız */}
        <div className="about-card">
          <h3>Amacımız-Yaklaşımımız</h3>
          <p>
            Çocukların yarının mutlu ve özgür bireyleri olması ve onlara gerekli eğitim ortamlarının sağlanması amacıyla 2015 yılında “Mutlu ve Özgür Çocuk Öğrenir” diyerek yola çıktık. 
            Bu yolculuğun başından beri okullarımızda eleştirel ve demokratik bir eğitim yaklaşımını benimsiyoruz.
          </p>
          <p>
            Çocuklara yenilikçi düşünme biçimi ile ilgi çekici deneyimlere katılma fırsatı sunulduğunda, öğrenmenin daha kalıcı olacağına inanıyoruz. Öğrenme ne kadar doğal olursa o kadar etkili olur. 
            Çocuğu merkeze alan yaklaşımımızla oluşturduğumuz öğrenme ortamlarında çocuklar eğlenerek ve güvenle öğreniyor.
          </p>
          <p>
            Yeldeğirmeni Eğitim Kurumlarında çocuklar:
            <ul>
              <li>Eğitim sürecine kendine özgü öğrenme biçimleri ile kendi ritminde aktif olarak katılır.</li>
              <li>Karar alma süreçlerine dahil olur ve demokratik değerleri özümseyerek yetişir.</li>
              <li>Ekolojik farkındalık kazanır, doğada öğrenir ve doğayı korur.</li>
              <li>Bilimsel ve evrensel bir bakış açısı kazanır, teknolojiyi bir araç olarak kullanır.</li>
            </ul>
          </p>
        </div>

        {/* Misyon & Vizyon */}
        <div className="about-card">
          <h3>Misyonumuz &amp; Vizyonumuz</h3>
          <p>
            <strong>Misyonumuz:</strong> Alternatif eğitim anlayışıyla, her çocuğun özgün potansiyelini keşfetmesini destekleyen; merak eden, sorgulayan, doğayla uyumlu, yaratıcı, çözüm odaklı ve duyarlı bireyler yetiştirmektir.
          </p>
          <p>
            Öğrenmeyi bir yaşam biçimi olarak benimseyen çocukların; özdisiplinli, özgüvenli ve topluma katkı sunan bireyler olarak gelişmelerine katkı sağlamak temel görevimizdir.
          </p>
          <p>
            <strong>Vizyonumuz:</strong> Eğitimi yalnızca akademik başarıdan ibaret görmeyen; bireyin zihinsel, duygusal, sosyal ve etik yönlerini destekleyen, özgürlükçü ve demokratik bir okul modeliyle ilham veren bir öğrenme topluluğu oluşturmaktır.
          </p>
          <p>
            Amacımız, gelecekte kendi yolunu çizebilen, yaşamla bağ kuran, çok yönlü bireylerin yetiştiği bir eğitim ortamı sunmaktır.
          </p>
        </div>

      </div>
    </section>
  );
}
